exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-delete-warning-text[data-v-90932834] {\n  color: #DE3024;\n  font-weight: 500;\n}\n.confirm-delete-phrase[data-v-90932834] {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 20px;\n}\n.confirm-delete-phrase-text[data-v-90932834] {\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  white-space: pre-wrap;\n  color: #6b7280;\n}\n.confirm-delete-phrase-text .matched[data-v-90932834] {\n  color: #dc2626;\n}", ""]);

// exports
